import { DataSource } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { PartnerService } from '../../../services/partner.service';
import { ImportService } from '../../../services/import.service';
import { MatPaginator } from '@angular/material/paginator';

import { DataManagementCreateShowModalComponent } from '../../_modals/data-management-create-show-modal/data-management-create-show-modal.component';
import { MapProToPartnerGroupModalComponent } from '../../_modals/map-pro-to-partner-group-modal/map-pro-to-partner-group-modal.component';
import { ShowMapperModalComponent } from '../../_modals/show-mapper-modal/show-mapper-modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-partner-group-mapper-table',
  templateUrl: './partner-group-mapper-table.component.html',
  styleUrls: ['./partner-group-mapper-table.component.scss']
})
export class PartnerGroupMapperTableComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  displayedColumns: string[] = [
    'title',
    'network',
    'action'
    // 'name',
    // 'year',
    // 'quarter',
    // 'action'
    // 'artist__user__first_name',
    // 'genre',
    // 'sub_genre',
    // 'created_at',
    // 'updated_at',
    // 'approved_at',
    // 'status',
    // 'action',
  ];

  // tableData: MatTableDataSource<any>;
  
  tableData: MatTableDataSource<any>;
  profileId: any;
  isFetchingTableData = false;

  searchFilterFocused = false;
  searchString: any;

  proShows: any;
  partnerPros: any;
  partnerGroups: any;

  constructor(private partnerService: PartnerService, private importService: ImportService,
              private dialog: MatDialog, private route: ActivatedRoute,
              private router: Router,
              ) {
  }

  ngOnInit() {

    // When modal closes, refresh data (simple pipe through service file, this idea is used similarly in several spots)
    this.partnerService.modalClosed$.subscribe( () => {
      this.isFetchingTableData = true;
      this.importService.getImportDetailsMappedShows(this.profileId, 1).subscribe((res: any) => {
        this.partnerPros = res;
        // this.partnerPros = this.filterPartnerGroupShows(res);
        this.tableData = new MatTableDataSource<any>(this.partnerPros);
        this.tableData.paginator = this.paginator;
        this.isFetchingTableData = false;
      });  
    });

    // set profileID off the URL parameter
    // other importService subscription stuff is here for Robert's pieces until those can be undone
    this.route.queryParams.subscribe(params => {
      this.profileId = params['profileId'];
      console.log('Profile ID:', this.profileId);

      if (this.profileId) {
        this.importService.getImportProMappedHeadersProfile(this.profileId).subscribe((x) => {
          this.importService.setImportProMappedHeadersProfile(x);

          //this needs to be set for the header to display the appropriate buttons
          this.importService.setImportedFilePath(x.filePath);

        })
      }
    });

    // reload table when a modal closes (WITH SUCCESS, not canceled)
    // this.partnerService.modalClosed$.subscribe(() => {
    //   this.isFetchingTableData = true;
    //   this.importService.getImportDetails(this.profileId, 1).subscribe((res: any) => {
    //     this.tableData = new MatTableDataSource<any>(res);
    //     this.tableData.paginator = this.paginator;
    //     this.isFetchingTableData = false;
    //   });
    // });


    // this.isFetchingTableData = true;
    // this.importService.getImportDetails(this.profileId, 1).subscribe( (res: any) => {
    //   this.tableData = new MatTableDataSource<any>(res);
    //   this.tableData.paginator = this.paginator;
    //   this.isFetchingTableData = false;
    // });

    this.partnerService.getAllPROShows().subscribe( (res: any) => {
      this.proShows = res;
    });

    this.partnerService.getPartnerGroups().subscribe((res: any) => {
      this.partnerGroups = res;
    });

    // this.isFetchingTableData = true;
    // this.importService.getImportDetailsMappedShows(this.profileId, 1).subscribe((res: any) => {
    //   this.partnerPros = res;
    //   // this.partnerPros = this.filterPartnerGroupShows(res);
    //   this.tableData = new MatTableDataSource<any>(this.partnerPros);
    //   this.tableData.paginator = this.paginator;
    //   this.isFetchingTableData = false;
    // })

    this.isFetchingTableData = true;
    this.importService.getImportDetailsMappedShows(this.profileId, 1).subscribe((res: any) => {
      this.partnerPros = res;
      // this.partnerPros = this.filterPartnerGroupShows(res);
      this.tableData = new MatTableDataSource<any>(this.partnerPros);
      this.tableData.paginator = this.paginator;
      this.isFetchingTableData = false;
    });

  }

  ngAfterViewInit() {
  }


  // filterPartnerGroupShows(shows: any) {
  //   return shows.filter(show => !show.partnerGroupId);
  // }

  getSearchVal(event: any){
    this.searchString = event.trim();
  }

  filterData(search: any) {
    this.tableData.filter = search;
  }

  openCreateShowModal(show: any) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: show.showName,
      partnerGroups: this.partnerGroups
    };
    this.dialog.open(DataManagementCreateShowModalComponent, dialogConfig);
  }

  openMapShowModal(show: any) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      // title: show.showName,
      importedProShow: show,
      shows: this.proShows
    };
    this.dialog.open(ShowMapperModalComponent, dialogConfig);
  }

  navigateToShowsTable(proImport: any) {
    // uncomment when data comes from server and proper profileIds can be assigned
    const id: string = proImport.profileId;
    // this.router.navigate(['/data/pro/show-mapper?profileId=' + id]);
  }

  navigateToPartnerGroupsTable(proImport: any) {
    // uncomment when data comes from server and proper profileIds can be assigned
    const id: string = proImport.profileId;
    this.router.navigate(['/data/pro/partner-group-mapper']);
  }

  openMapToPartnerGroupModal(show: any) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      // title: show.showName,
      proShows: this.proShows,
      importShow: show,
      partnerGroups: this.partnerGroups
    };
    this.dialog.open(MapProToPartnerGroupModalComponent, dialogConfig);
  }
}
